/**六合彩生肖计算 */
// type：生成那种情况下的生肖
//arr，每个元素带有num,sx属性
export function get_lhc_sx(type, arr) {
  let idx = 0;

  if (type == "开奖") {
    for (let i = 0; i < arr.length; i++) {
      idx = arr[i].num; //计算生肖排序
      // let arr_sx = ['鼠', '牛', '虎', '兔', '龙', '蛇', '马', '羊', '猴', '鸡', '狗', '猪',];

      let time = arr[i].lottery_open.split('-');

      if (new Date(`${time[0]}-${time[1]}-${time[2]}`).getTime() < 1674316799000) {
        switch (Number(idx)) {
          case 12:
          case 24:
          case 36:
          case 48:
            arr[i].sx = '兔';
            break;

          case 11:
          case 23:
          case 35:
          case 47:
            arr[i].sx = '龙';
            break;

          case 10:
          case 22:
          case 34:
          case 46:
            arr[i].sx = '蛇';
            break;

          case 9:
          case 21:
          case 33:
          case 45:
            arr[i].sx = '马';
            break;

          case 8:
          case 20:
          case 32:
          case 44:
            arr[i].sx = '羊';
            break;

          case 7:
          case 19:
          case 31:
          case 43:
            arr[i].sx = '猴';
            break;

          case 6:
          case 18:
          case 30:
          case 42:
            arr[i].sx = '鸡';
            break;

          case 5:
          case 17:
          case 29:
          case 41:
            arr[i].sx = '狗';
            break;

          case 4:
          case 16:
          case 28:
          case 40:
            arr[i].sx = '猪';
            break;

          case 3:
          case 15:
          case 27:
          case 39:
            arr[i].sx = '鼠';
            break;

          case 2:
          case 14:
          case 26:
          case 38:
            arr[i].sx = '牛';
            break;

          case 1:
          case 13:
          case 25:
          case 37:
          case 49:
            arr[i].sx = '虎';
            break;
        }
      } else {
        switch (Number(idx)) {
          case 12:
          case 24:
          case 36:
          case 48:
            arr[i].sx = '龙';
            break;

          case 11:
          case 23:
          case 35:
          case 47:
            arr[i].sx = '蛇';
            break;

          case 10:
          case 22:
          case 34:
          case 46:
            arr[i].sx = '马';
            break;

          case 9:
          case 21:
          case 33:
          case 45:
            arr[i].sx = '羊';
            break;

          case 8:
          case 20:
          case 32:
          case 44:
            arr[i].sx = '猴';
            break;

          case 7:
          case 19:
          case 31:
          case 43:
            arr[i].sx = '鸡';
            break;

          case 6:
          case 18:
          case 30:
          case 42:
            arr[i].sx = '狗';
            break;

          case 5:
          case 17:
          case 29:
          case 41:
            arr[i].sx = '猪';
            break;

          case 4:
          case 16:
          case 28:
          case 40:
            arr[i].sx = '鼠';
            break;

          case 3:
          case 15:
          case 27:
          case 39:
            arr[i].sx = '牛';
            break;

          case 2:
          case 14:
          case 26:
          case 38:
            arr[i].sx = '虎';
            break;

          case 1:
          case 13:
          case 25:
          case 37:
          case 49:
            arr[i].sx = '兔';
            break;
        }
      }
    }
  }

  if (type == "初始化") {
    // console.log(arr)
    for (let i = 0; i < arr.length; i++) {
      for (let j = 0; j < arr[i].betclass.length; j++) {
        for (let l = 0; l < arr[i].betclass[j].betclass_nums.length; l++) {
          idx = arr[i].betclass[j].betclass_nums[l].num;

          switch (Number(idx)) {
            case 12:
            case 24:
            case 36:
            case 48:
              arr[i].betclass[j].name = '龙';
              break;

            case 11:
            case 23:
            case 35:
            case 47:
              arr[i].betclass[j].name = '蛇';
              break;

            case 10:
            case 22:
            case 34:
            case 46:
              arr[i].betclass[j].name = '马';
              break;

            case 9:
            case 21:
            case 33:
            case 45:
              arr[i].betclass[j].name = '羊';
              break;

            case 8:
            case 20:
            case 32:
            case 44:
              arr[i].betclass[j].name = '猴';
              break;

            case 7:
            case 19:
            case 31:
            case 43:
              arr[i].betclass[j].name = '鸡';
              break;

            case 6:
            case 18:
            case 30:
            case 42:
              arr[i].betclass[j].name = '狗';
              break;

            case 5:
            case 17:
            case 29:
            case 41:
              arr[i].betclass[j].name = '猪';
              break;

            case 4:
            case 16:
            case 28:
            case 40:
              arr[i].betclass[j].name = '鼠';
              break;

            case 3:
            case 15:
            case 27:
            case 39:
              arr[i].betclass[j].name = '牛';
              break;

            case 2:
            case 14:
            case 26:
            case 38:
              arr[i].betclass[j].name = '虎';
              break;

            case 1:
            case 13:
            case 25:
            case 37:
            case 49:
              arr[i].betclass[j].name = '兔';
              break;
          }
        }
      }
    }
  }

  if (type == "快速下注初始化") {
    // console.log(arr)
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].title == '生肖') {
        for (let j = 0; j < arr[i].nums.length; j++) {
          idx = arr[i].nums[j];

          switch (Number(idx)) {
            case 12:
            case 24:
            case 36:
            case 48:
              arr[i].name = '龙';
              break;

            case 11:
            case 23:
            case 35:
            case 47:
              arr[i].name = '蛇';
              break;

            case 10:
            case 22:
            case 34:
            case 46:
              arr[i].name = '马';
              break;

            case 9:
            case 21:
            case 33:
            case 45:
              arr[i].name = '羊';
              break;

            case 8:
            case 20:
            case 32:
            case 44:
              arr[i].name = '猴';
              break;

            case 7:
            case 19:
            case 31:
            case 43:
              arr[i].name = '鸡';
              break;

            case 6:
            case 18:
            case 30:
            case 42:
              arr[i].name = '狗';
              break;

            case 5:
            case 17:
            case 29:
            case 41:
              arr[i].name = '猪';
              break;

            case 4:
            case 16:
            case 28:
            case 40:
              arr[i].name = '鼠';
              break;

            case 3:
            case 15:
            case 27:
            case 39:
              arr[i].name = '牛';
              break;

            case 2:
            case 14:
            case 26:
            case 38:
              arr[i].name = '虎';
              break;

            case 1:
            case 13:
            case 25:
            case 37:
            case 49:
              arr[i].name = '兔';
              break;
          }
        }
      }
    }
  }

  return arr;
}